// extracted by mini-css-extract-plugin
module.exports = {"label":"label-module--label--2rzYb","secondary":"label-module--secondary--1RZwg","tertiary":"label-module--tertiary--1XBLv"};